import { useAuth, useUser } from '@clerk/clerk-react'
import { setAgentsApiBaseUrl } from '@saaga/shared/store/agents-api.store'
import { selectTenant } from '@saaga/shared/store/slices/billing.slice'
import { useAppSelector } from '@saaga/shared/store/store'
import {
  setPlanGetter,
  setTenantIdGetter,
  setTokenGetter,
  setUserIdGetter,
} from '@saaga/shared/store/token-provider.store'
import { useEffect } from 'react'

import { useOrganizationEarlyAccess } from './use-organization-early-access.hook'

const AGENTS_API_URL = import.meta.env.VITE_API_AGENTS
const EARLY_ACCESS_PLAN = 'pro'

export const useAgentsApiConfig = (): void => {
  const { getToken, orgId } = useAuth()
  const { user } = useUser()
  const billingTenant = useAppSelector(selectTenant)
  const { isEarlyAccess } = useOrganizationEarlyAccess()

  useEffect(() => {
    setTokenGetter(getToken)
    setAgentsApiBaseUrl(AGENTS_API_URL)
  }, [getToken])

  useEffect(() => {
    setTenantIdGetter(() => orgId ?? null)
  }, [orgId])

  useEffect(() => {
    setUserIdGetter(() => user?.id ?? null)
  }, [user?.id])

  useEffect(() => {
    setPlanGetter(() => {
      if (isEarlyAccess) return EARLY_ACCESS_PLAN
      return billingTenant?.subscriptionName ?? null
    })
  }, [billingTenant?.subscriptionName, isEarlyAccess])
}
